import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-worst-technical-pages',
  templateUrl: './worst-technical-pages.component.html',
  styleUrls: ['./worst-technical-pages.component.css']
})
export class WorstTechnicalPagesComponent {
  @Input() pages: any[] = [];
  @Output() pageSelected = new EventEmitter<any>();

  selectPage(page: any) {
    this.pageSelected.emit(page);
  }

  getScoreColor(score: number) {
    if (score >= 80) return 'text-success';
    if (score >= 50) return 'text-warning';
    return 'text-danger';
  }
}
